export const appendImportDefaults = (formData, state) => {
    const defaults = state?.importDefaults || {};
    for (const key in defaults) {
        if (defaults[key] !== undefined && defaults[key] !== null && defaults[key] !== '') {
            formData.append(key, defaults[key]);
        }
    }
};
